// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ShowBox from "./show-box.js"

const modelClassData = {
  "attributes": {
    "attribute_name": {
      "column": {
        "default": null,
        "name": "attribute_name",
        "null": false,
        "type": "string"
      },
      "name": "attribute_name",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "path": {
      "column": {
        "default": null,
        "name": "path",
        "null": false,
        "type": "jsonb"
      },
      "name": "path",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": null,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "show_box_id": {
      "column": {
        "default": null,
        "name": "show_box_id",
        "null": false,
        "type": "uuid"
      },
      "name": "show_box_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ShowBoxAttribute",
  "collectionKey": "show_box_attributes",
  "collectionName": "show_box_attributes",
  "i18nKey": "show_box_attribute",
  "camelizedLower": "showBoxAttribute",
  "name": "ShowBoxAttribute",
  "nameDasherized": "show-box-attribute",
  "pluralName": "show_box_attributes",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ShowBox",
      "collectionName": "show_boxes",
      "foreignKey": "show_box_id",
      "name": "show_box",
      "macro": "belongs_to",
      "resource_name": "ShowBox",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "attribute_name",
      "column": {
        "default": null,
        "name": "attribute_name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "path",
      "column": {
        "default": null,
        "name": "path",
        "null": false,
        "type": "jsonb"
      }
    },
    {
      "name": "position",
      "column": {
        "default": null,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "show_box_id",
      "column": {
        "default": null,
        "name": "show_box_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ShowBox",
      "collectionName": "show_boxes",
      "foreignKey": "show_box_id",
      "name": "show_box",
      "macro": "belongs_to",
      "resource_name": "ShowBox",
      "through": null
    }
  ],
  "paramKey": "show_box_attribute",
  "primaryKey": "id"
}

/** Frontend model for ShowBoxAttribute. */
export default class ShowBoxAttribute extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  attributeName() {
    return this.readAttributeUnderscore("attribute_name")
  }

  /** @returns {boolean} */
  hasAttributeName() {
    const value = this.attributeName()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {Record<string, any> | Array<any>} */
  path() {
    return this.readAttributeUnderscore("path")
  }

  /** @returns {boolean} */
  hasPath() {
    const value = this.path()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {string} */
  showBoxId() {
    return this.readAttributeUnderscore("show_box_id")
  }

  /** @returns {boolean} */
  hasShowBoxId() {
    const value = this.showBoxId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./show-box.js").default | null} */
  showBox() {
    return this._readBelongsToReflection({modelClass: ShowBox, reflectionName: "show_box"})
  }

  /** @returns {Promise<import("./show-box.js").default | null>} */
  loadShowBox() {
    if (!("showBoxId" in this)) throw new Error("Foreign key method wasn't defined: showBoxId")

    const id = this.showBoxId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "show_box",
        model: this,
        modelClass: ShowBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./show-box.js").default | null>} */
  ensureShowBoxLoaded() {
    return this.ensureAssociationLoaded("show_box")
  }
}
